'use strict';

const isNative = require('./isNative');

/**
 * Asserts given object isNative(), or throws an exception.
 *
 * @param  {[type]} obj [description]
 * @throws {TypeError}
 */
module.exports = function assertNative (obj) {
  if (!isNative(obj)) {
    throw new TypeError(`${obj} is not native to this execution context!`);
  }
};



// WEBPACK FOOTER //
// ./lib/rlink-type-utils/assertNative.js